import { UnredeemedPlansTable } from "./UnredeemedPlansTable.tsx";
import { LoadingRows } from "../UI/Loading/LoadingRows.tsx";
import { useNavigate } from "react-router-dom";
import { CreateBulkClassRoomScreenPath } from "./CreateBulkClassRoomScreen";
import { Layout } from "../UI/Layout/Layout.tsx";
import { Card } from "../UI/Card.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { useGetAllBulkClassRoomCreationIntents } from "./useGetAllBulkClassRoomCreationIntents";

export const UnredeemedPlansScreenPath = "/unredeemed-1on1-plans";

export const UnredeemedPlansScreen = () => {
  const { intents, loading, error } = useGetAllBulkClassRoomCreationIntents(
    100,
    0,
  );
  const navigate = useNavigate();

  return (
    <Layout>
      <Card>
        <ScreenTitleBlock
          title={"Intents Creazione Bulk ClassRoom"}
          breadCrumbs={
            <BreadCrumbsWrapper>
              <BreadCrumbsItem title={"Intents Creazione Bulk ClassRoom"} />
            </BreadCrumbsWrapper>
          }
          ctaLabel="Crea classi in bulk"
          ctaOnClick={() => navigate(CreateBulkClassRoomScreenPath)}
        />
      </Card>
      <div className={"mt-4"}>
        <Card>
          {loading && <LoadingRows />}

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
              Errore nel caricamento degli intents: {error.message}
            </div>
          )}

          {!loading && !error && intents.length === 0 && (
            <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded">
              Non ci sono intents di creazione bulk classroom
            </div>
          )}

          {!loading && !error && intents.length > 0 && (
            <UnredeemedPlansTable
              intents={intents}
              onOpenIntent={(intentId) =>
                navigate(`/bulk-classrooms/intent/${intentId}`)
              }
            />
          )}
        </Card>
      </div>
    </Layout>
  );
};
